import CourierConfig from "@/components/couriers/config/CourierConfig";
import InvoiceAudit from "@/components/couriers/billing/InvoiceAudit";
export default [
  {
    path: "/courierconfig",
    name: "CourierConfig",
    component: CourierConfig,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: "/invoice-audit",
    name: "InvoiceAudit",
    component: InvoiceAudit,
    meta: {
      requiresAuthentication: true
    }
  }
];
